exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  background:#ECF6FF;\n  color:black;\n  position:relative;\n  height:400px;\n  overflow:hidden;\n  display:block;\n}\n\n.image-container {\n  padding:50px;\n  display:table;\n  width:100%;\n}\n\n.image-preview {\n  display:table-cell;\n  vertical-align:top;\n  text-align:right;\n  width:30%;\n}\n\n.image-preview img {\n  border:5px solid white;\n  height:300px;\n}\n\n.image-info {\n  font-size:1.5rem;\n  width:70%;\n  padding-right:50px;\n  display:table-cell;\n  vertical-align:middle;\n}\n\napp-image {\n  display:block;\n  width:100%;\n  height:300px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/image-preview/image-preview.component.css
// module id = 212
// module chunks = 1